import {HttpClient, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import { Injectable } from '@angular/core';
import {User} from '../models/user';
import {Observable, of, throwError} from 'rxjs';
import { catchError, tap, map } from 'rxjs/operators';
import {ApiResponse} from '../models/api.response';


const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};
const apiUrl = '/gsb/users';
@Injectable()
export class UserService {
    constructor(private http: HttpClient) { }

    getAll(): Observable<any> {
      const url = `${apiUrl}`;
      return this.http.get<any>(url);
    }

    getById(id: number) {
      const url = `${apiUrl}/${id}`;
      return this.http.get<User>(url);
    }

    create(user: User) {
      return this.http.post<User>(apiUrl + '/save', user, httpOptions);
    }

    update(id, user: User) {
      const url = `${apiUrl}/${id}`;
      return this.http.put(url, user, httpOptions);
    }

    delete(id: number) {
      const url = `${apiUrl}/${id}`;
      return this.http.delete<User>(url, httpOptions);
    }

    // others function

    resetPassword(id: number) {
      const url = `${apiUrl}/password/${id}`;
      return this.http.post<User>(url, httpOptions);
    }
}
